export const FETCH_MB_CURRENCY = 'FETCH_MB_CURRENCY';
export const FETCH_MB_COMMENTS = 'FETCH_MB_COMMENTS';
export const FETCH_MB_ARCHIVE = 'FETCH_MB_ARCHIVE';
export const FETCH_CURRENCY_YEAR_ARCHIVE = 'FETCH_CURRENCY_YEAR_ARCHIVE';
export const FETCH_NBU_CURRENCY = 'FETCH_NBU_CURRENCY';
export const FETCH_ALL_CURRENCY_LIST = 'FETCH_ALL_CURRENCY_LIST';
export const FETCH_ALL_CITIES_LIST = 'FETCH_ALL_CITIES_LIST';
export const FETCH_NEWS = 'FETCH_NEWS';
export const FETCH_VIDEOS = 'FETCH_VIDEOS';
export const FETCH_DISCUSSIONS = 'FETCH_DISCUSSIONS';
export const FETCH_NBU_CURRENCY_LIST = 'FETCH_NBU_CURRENCY_LIST';
export const FETCH_ARTICLES = 'FETCH_ARTICLES';
export const FETCH_COMPANIES_NEWS = 'FETCH_COMPANIES_NEWS';
export const FETCH_VA_CURRENCY_LIST = 'FETCH_VA_CURRENCY_LIST';
